import { ListItem } from '@tiptap/extension-list'

export type { ListItemOptions } from '@tiptap/extension-list'
export { ListItem } from '@tiptap/extension-list'

export default ListItem
